<template>
  <div class="DropdownMenuProducts">
    <div class="groupItems">
      <div v-for="item in entries" :key="item.title" class="groupEntry">
        <MenuGroupItem class="menuItem" :class="item.description && 'verbose'" v-bind="item" />
      </div>
    </div>
  </div>
</template>

<script>
import MenuGroupItem from '../shared/MenuGroupItem.vue'

export default {
  components: {
    MenuGroupItem,
  },
  props: {
    entries: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.menuItem {
  --title-font-size: var(--font-size-2);
}
.groupItems {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: var(--spacing-9);
  row-gap: var(--spacing-8);
}
.menuItem.verbose {
  min-height: 4.5rem;
}
.groupEntry {
  max-width: 15rem;
}
</style>
